import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholiwaterparkonlinebooking() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Water Park Online Booking',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Water Park Online Booking',
        headingDescription: 'Looking for Morachi Chincholi water park online booking? Anand Krushi Paryatan Kendra offers a hassle-free way to plan your perfect day filled with fun and relaxation. Just 55 km from Pune, this agri-tourism destination features an exciting water park experience with a rain dance area, clean swimming pools, boating, and other outdoor activities set in a lush rural environment. With options for online booking through their official website, it is easy to reserve spots for school groups, families, or corporate outings. Safe, scenic, and packed with activities, Anand Krushi Paryatan Kendra is one of the most convenient and enjoyable water park getaways near Pune.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
"topPlaces": [
  {
    "title": "Peacock Spotting & Nature Trails",
    "description": "Start the picnic with guided nature walks through farmlands, ponds, and orchards. Students often spot free-roaming peacocks, parakeets, and bulbuls—great for early-morning adventures and nature photography."
  },
  {
    "title": "Bullock Cart & Tractor Rides",
    "description": "Take students on fun, bumpy rides across village tracks in decorated bullock carts and farm tractors. This rural experience is both entertaining and educational, offering insight into village transport heritage."
  },
  {
    "title": "Traditional Village Games",
    "description": "Organise group games like kho-kho, kabaddi, lagori, sack race, and gilli-danda on open playgrounds. These energy-packed activities promote teamwork, physical fitness, and joyful interaction among students."
  },
  {
    "title": "Interactive Farm Learning",
    "description": "Teachers can lead hands-on stations where students plant seeds, water saplings, create compost pits, and learn about seasonal crops and organic farming—all guided by local farmers."
  },
  {
    "title": "Animal Feeding & Dairy Visit",
    "description": "Visit the farm’s dairy section where students can feed calves, milking demonstration sessions, and observe goats and ducks—a wonderful way to learn about farm animals and their care."
  },
  {
    "title": "Craft & Diya-Painting Workshops",
    "description": "Set up creative corners for clay pottery, diya painting, and leaf-print crafts. These activity sessions help students explore their artistic side and take home handmade souvenirs."
  },
  {
    "title": "Nutritious Rural Meals",
    "description": "Serve wholesome Maharashtrian-style meals—breakfast (poha, upma), unlimited thali lunch on banana leaves, and evening snacks. Meals are cooked fresh, healthy, and kid-friendly."
  },
  {
    "title": "Rain Dance & Splash Zone",
    "description": "Cool off after afternoon sessions with fun rain dance and splash pool time. DJ-backed music and safe pool areas make this a favorite for summer trips and enthusiastic kids."
  },
  {
    "title": "Puppet/Magic Show & Cultural Fun",
    "description": "Students enjoy engaging puppet shows, magic acts, or folk storytelling sessions in a shaded outdoor space—combining laughter, culture, and entertainment."
  },
  {
    "title": "Group Photo Spots & Return Gifts",
    "description": "End the day with a group photo under iconic village backdrops—like bullock carts or peacock trails. Students also receive small take-home tokens like clay tokens or seed packets."
  }
],




"services": [
  {
    "name": "Book Water Park Tickets Online",
    "description": "Convenient and secure online ticketing system allowing families and groups to book water park entry in advance, avoiding queues and ensuring smooth entry on the chosen date."
  },
  {
    "name": "Family Water Park Booking Near Pune",
    "description": "Special family packages including entry, locker facilities, and meal options, designed to provide a hassle-free, fun-filled day for all ages close to Pune."
  },
  {
    "name": "Water Park Packages with Lunch",
    "description": "Inclusive packages offering entry tickets along with hygienic, farm-fresh vegetarian lunch served at designated dining zones, catering to group dietary needs."
  },
  {
    "name": "School Group Water Park Booking",
    "description": "Customized group booking options for schools with special discounts, safe supervision arrangements, and educational breaks integrated within the fun day."
  },
  {
    "name": "Weekend Water Park Pass Online",
    "description": "Weekend-specific passes available for quick online purchase, ensuring families and groups can enjoy peak time visits with ease and instant confirmation."
  },
  {
    "name": "Farm + Water Park Combo Booking",
    "description": "Unique packages combining immersive farm education visits with thrilling water park experiences, perfect for school groups and family outings seeking both learning and recreation."
  },
  {
    "name": "Online Reservation for Water Activities",
    "description": "Advance booking for special water rides, rain dance sessions, and adventure pools through a user-friendly online portal, guaranteeing preferred time slots."
  },
  {
    "name": "Budget-Friendly Water Park Entry Pass",
    "description": "Affordable ticket options with no compromise on fun or safety, aimed at families and groups looking for value-packed water park visits near Pune."
  },
  {
    "name": "Booking for Kids Water Rides",
    "description": "Secure and supervised booking of age-appropriate water rides ensuring maximum safety and enjoyment for younger children with trained lifeguard support."
  },
  {
    "name": "Rain Dance Online Entry Tickets",
    "description": "Exclusive rain dance event tickets available online, offering a splashy, fun-filled experience for all ages with music and vibrant atmosphere."
  },
  {
    "name": "Group Discount Water Park Booking",
    "description": "Special group discounts for large families, school groups, and corporate outings, with easy online booking and instant confirmation to encourage group fun."
  },
  {
    "name": "Water Park Availability Status",
    "description": "Real-time updates on water park crowd levels, ride availability, and weather conditions to help visitors plan their trips efficiently and avoid peak congestion."
  },
  {
    "name": "Morachi Chincholi Water Park Deals Online",
    "description": "Exclusive online deals and seasonal offers for water park entry at Morachi Chincholi, bundled with farm activities for a complete day out."
  },
  {
    "name": "Instant Confirmation for Water Park Slots",
    "description": "Automated booking system providing immediate confirmation of selected dates and time slots, ensuring hassle-free planning and guaranteed entry."
  }
],
"tableData": [
  ["Book Water Park Tickets Online", "Family Water Park Booking Near Pune"],
  ["Water Park Packages with Lunch", "School Group Water Park Booking"],
  ["Weekend Water Park Pass Online", "Farm + Water Park Combo Booking"],
  ["Online Reservation for Water Activities", "Budget-Friendly Water Park Entry Pass"],
  ["Booking for Kids Water Rides", "Rain Dance Online Entry Tickets"],
  ["Group Discount Water Park Booking", "Water Park Availability Status"],
  ["Morachi Chincholi Water Park Deals Online", "Instant Confirmation for Water Park Slots"]
],



"whychoose": [
  {
    "WhyChooseheading": "Easy and Convenient Online Booking",
    "WhyChoosedescription": "Morachi Chincholi Water Park offers a seamless online booking system that allows visitors to reserve their spots from anywhere, ensuring hassle-free planning for school picnics, family outings, or group visits."
  },
  {
    "WhyChooseheading": "Flexible Packages for Day and Night Visits",
    "WhyChoosedescription": "Choose from multiple packages including day-only and day-night combos, designed to fit different group needs and budgets, with clear details on timings, meals, and activities available during each visit."
  },
  {
    "WhyChooseheading": "Comprehensive Activity Options",
    "WhyChoosedescription": "The water park features a wide range of attractions such as rain dance, swimming pool, bullock cart rides, tractor tours, adventure games, and cultural shows, providing fun and engagement for visitors of all ages."
  },
  {
    "WhyChooseheading": "Healthy and Delicious Meal Plans Included",
    "WhyChoosedescription": "All booking packages include thoughtfully prepared meals featuring authentic Maharashtrian cuisine made with fresh, organic ingredients, catering to various dietary preferences and ensuring a satisfying dining experience."
  },
  {
    "WhyChooseheading": "Safety and Supervision for All Visitors",
    "WhyChoosedescription": "Strict safety protocols and trained staff supervision guarantee a secure environment for children and adults alike, especially during water-based activities and adventure games."
  },
  {
    "WhyChooseheading": "Ideal Location Close to Pune",
    "WhyChoosedescription": "Located near Pune, Morachi Chincholi Water Park is easily accessible, making it a perfect destination for school picnics and family day trips without the hassle of long travel times."
  }
]




































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'How can I book tickets online for Morachi Chincholi Water Park?',
    answer: 'You can book tickets online through the official Morachi Chincholi website by selecting your preferred package and making an advance payment to confirm your booking.',
  },
  {
    id: 'FAQ2',
    question: 'What are the different ticket packages available for Morachi Chincholi Water Park?',
    answer: 'There are mainly two packages: Day Package (9:30 AM to 6:00 PM) and Day + Night Package, each with different rates for adults and children.',
  },
  {
    id: 'FAQ3',
    question: 'What are the ticket prices for adults and children?',
    answer: 'For the Day Package, adults pay ₹600 and children aged 4–10 pay ₹300, while children below 4 enter free. The Day + Night Package costs ₹1,400 for adults and ₹700 for children aged 4–10.',
  },
  {
    id: 'FAQ4',
    question: 'Are meals included in the Morachi Chincholi Water Park packages?',
    answer: 'Yes, the packages include meals such as breakfast, lunch, evening high tea, and dinner (for Day + Night Package) prepared with fresh ingredients.',
  },
  {
    id: 'FAQ5',
    question: 'What activities are available at Morachi Chincholi Water Park?',
    answer: 'Visitors can enjoy swimming, rain dance, boating, bullock cart rides, tractor rides, horse riding, adventure games, traditional rural games, and entertainment like magic and puppet shows.',
  },
  {
    id: 'FAQ6',
    question: 'Is advance booking recommended?',
    answer: 'Yes, it is strongly recommended to book at least 2–3 weeks in advance, especially during peak seasons and weekends.',
  },
  {
    id: 'FAQ7',
    question: 'What are the contact details for booking assistance?',
    answer: 'You can contact the park at +91 96891 25047, +91 96237 55047, or +91 96731 32497, or email at thopatemala@gmail.com for any booking queries.',
  },
  {
    id: 'FAQ8',
    question: 'Is there a cancellation or refund policy for online bookings?',
    answer: 'For cancellation and refund details, it is best to check directly with the park via their official website or contact numbers.',
  },
  {
    id: 'FAQ9',
    question: 'Are there facilities like washrooms and shaded rest areas in the park?',
    answer: 'Yes, the water park is equipped with clean washrooms, shaded seating, and designated rest areas to ensure visitor comfort.',
  },
  {
    id: 'FAQ10',
    question: 'Can large groups or school picnics be accommodated?',
    answer: 'Yes, the park is well-equipped to host large groups and school picnics with safety measures, activities, and meals tailored for group visits.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Sneha Patil, Teacher, Pune',
    feedback: "Booking online was very easy, and the entire group enjoyed the water park immensely. The staff was helpful, and the activities kept the children engaged throughout the day.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Prakash Deshmukh, Parent, Pimpri-Chinchwad',
    feedback: "Morachi Chincholi Water Park offers great fun combined with a safe environment. The online booking process was smooth, and the meals provided were delicious and fresh.",
    rating: 5,
  },
];






































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const waterParkBookingSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Water Park Online Booking",
  "name": "Morachi Chincholi Water Park Online Booking",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Anand Krushi Paryatan Kendra",
    "url": "https://morachichincholi.in/"
  },
  "description": "Book your Morachi Chincholi Water Park tickets online. Enjoy family-friendly water rides, rain dance, school group packages, and combo deals with farm activities. Instant booking with confirmed slots.",
  "areaServed": {
    "@type": "Place",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/water-park-booking",
    "eligibleCustomerType": "https://schema.org/Customer",
    "price": "500"
  }
};



    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Water Park Online Booking | Instant Confirmation & Deals</title>
  <meta 
    name="description" 
    content="Book Morachi Chincholi Water Park tickets online for family trips, school groups, and weekend fun. Packages include lunch, rain dance, kids rides, and combo farm experiences. Secure your slot now!" 
  />
  <meta 
    name="keywords" 
    content="Book water park tickets online, Morachi Chincholi water park booking, Family water park near Pune, School water park booking, Water park lunch packages, Weekend water park pass online, Online water ride reservation, Budget water park tickets, Rain dance entry booking, Group discount water park, Farm and water park combo deals, Water park slots availability, Water park booking near Pune, Kids water park ticket online, Instant confirmation water park" 
  />
  <script type="application/ld+json">
    {JSON.stringify(waterParkBookingSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholiwaterparkonlinebooking;